module.exports = __webpack_public_path__ + "static/media/transmission_oil.3d5aab12.svg";